/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import api from '~/services/api';
import toast from 'react-hot-toast';
import { IconRoundChat } from 'takeat-design-system-ui-kit';
import {
  Details,
  Complement,
  DetailsArea,
  DetailsHeader,
  OrdersInfo,
  ProductName,
  OrderCount,
} from './styles';

function OrderItem({ product, basket, baskets, setBaskets, isLate, isVeryLate, kds }) {
  const handleCheckProduct = useCallback(async (id, newCheckedStatus) => {
    // Guarda cópia do estado original para rollback
    const originalBaskets = JSON.parse(JSON.stringify(baskets));

    // Verifica se ao checar este item, todos os produtos (não cancelados) estarão checados
    const otherProducts = basket.kds_orders.filter(
      (order) => order.id !== id && !order.canceled_at
    );
    const allOthersChecked = otherProducts.every((order) => order.checked);
    const shouldFinishCard =
      newCheckedStatus && allOthersChecked && basket.status === 'doing';

    // Optimistic update
    const updatedBaskets = baskets.map((b) => {
      if (b.id === basket.id) {
        return {
          ...b,
          // Se vai finalizar, muda status e is_active para remover da tela imediatamente
          status: shouldFinishCard ? 'finished' : b.status,
          is_active: shouldFinishCard ? false : b.is_active,
          kds_orders: b.kds_orders.map((order) =>
            order.id === id ? { ...order, checked: newCheckedStatus } : order
          ),
        };
      }
      return b;
    });
    setBaskets(updatedBaskets);

    try {
      await api.put(`/restaurants/kds/basket/order-check/${id}`, {
        checked: newCheckedStatus,
      });

      // Se finalizou o card, chama a API de status
      if (shouldFinishCard) {
        await api.put(`/restaurants/kds/basket/status/${basket.id}`, {
          status: 'finished',
        });
      }
    } catch (err) {
      // Reverte para o estado original
      setBaskets(originalBaskets);
      toast.error('Erro ao atualizar item');
    }
  }, [baskets, setBaskets, basket]);

  return (
    <OrdersInfo isLate={isLate} isVeryLate={isVeryLate} status={basket?.status}>
      <span style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
        {basket?.status === 'doing' && !product.canceled_at && (
          <span>
            <input
              type="checkbox"
              width={25}
              checked={product.checked}
              onChange={() => {
                handleCheckProduct(product?.id, !product.checked);
              }}
            />
          </span>
        )}

        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginLeft: 10,
            width: '100%',
          }}
        >
          <span
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            {!kds?.group_items && basket?.order_count > 1 && (
              <OrderCount>{`${product?.number} de ${basket.order_count}`}</OrderCount>
            )}
            <ProductName
              canceled={product?.canceled_at}
              isLate={isLate}
              checked={product?.checked}
              isVeryLate={isVeryLate}
            >
              {product?.amount}x {product?.name}
            </ProductName>
          </span>

          <span style={{ marginTop: 8, flexWrap: 'wrap' }}>
            {product?.complements &&
              product?.complements.length > 0 &&
              product?.complements?.map((comp) => (
                <Complement
                  isVeryLate={isVeryLate}
                  isLate={isLate}
                  key={comp?.id}
                >
                  {comp.amount}x {comp.name}
                  {comp.details && comp.details.split("\n").map((line) => (
                    <>
                      <br />
                      - {line.replace(/\(R\$\d+,\d{2}\);?/g, "").replace(/;$/, "").trim()}
                    </>
                  ))}
                </Complement>
              ))}
          </span>

          {(product.details || basket.details) && (
            <DetailsArea>
              <DetailsHeader>
                <IconRoundChat />{' '}
                <span style={{ fontSize: 14, fontWeight: 600 }}>
                  Observações
                </span>
              </DetailsHeader>

              <Details
                style={{
                  marginLeft: 4,
                  wordWrap: 'break-word',
                  maxWidth: '21rem',
                }}
              >
                {product.details || ''}
                {basket.details
                  ? <div style={{ fontWeight: 600, fontSize: 12 }}> *{basket.details} </div>
                  : ''
                }
              </Details>
            </DetailsArea>
          )}
        </span>
      </span>

      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
          fontWeight: 'bold',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span style={{ fontSize: 18 }}>{product?.average_time}</span>
        <span style={{ fontSize: 10, marginTop: -6 }}>min</span>
      </span>
    </OrdersInfo>
  );
}

export default OrderItem;
